<script setup lang="ts">

const props = withDefaults(
  defineProps<{modelValue: number; disabled: boolean}>(),
  {
    modelValue: 0,
    disabled: false,
  });

const hoverIndex = ref(0);
const rating = ref(0);

const hoverOver = (index: number) => {
  if (props.disabled) {
    return;
  }

  hoverIndex.value = index;
};

const hoverOut = () => {
  hoverIndex.value = 0;
};

const setRating = (index: number) => {
  if (props.disabled) {
    return;
  }

  rating.value = index;
  emit('update:modelValue', index);
};

const emit = defineEmits<{
  (e: 'update:modelValue', val: number): void;
}>();
</script>

<template>
  <div
    class="rating"
    :class="{disabled: props.disabled}"
    @mouseout="hoverOut"
  >
    <MIcon
      v-for="index in 5"
      :key="index"
      icon="star"
      :class="{'active': index <= props.modelValue && hoverIndex === 0, 'highlight': index <= hoverIndex}"
      @mouseover="hoverOver(index)"
      @click="setRating(index)"
    />
  </div>
</template>

<style scoped lang="scss">
.rating {
  padding: 0;
  display: flex;
  justify-content: center;

  .m-icon {
    font-size: 1.5rem;
    cursor: pointer;
    color: var(--palette-neutral-30);
    transition: color 0.1s ease-in-out;
    margin-right: 0.5rem;

    &.active,
    &.highlight {
      color: var(--palette-neutral-70);
    }
  }

    &.disabled {
    .m-icon {
      cursor: not-allowed;
      opacity: 0.5;
    }
  }
}
</style>